(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
var cookie_notice = ( function( $ ) {

	var $notice = false;
	var $html = false;

	var _init = function() {
		$notice = $( '#cookie-notice' );
		$html = $( 'html' );

		_setup();
	};

	var _setup = function() {
		if ( ! is_accepted() ) {
			$notice.find( '.accept' ).on( 'click', _accept_click_event );

			open();
		}
	};

	var _accept_click_event = function( e ) {
		e.preventDefault();

		accept();
		close();
	};

	var accept = function() {
		$.cookie( 'cookies_accepted', 'true', { expires: 365 } );
	};

	var is_accepted = function() {
		return $.cookie( 'cookies_accepted' );
	};

	var open = function() {
		$html.addClass( 'cookie-bar-active' );
	};

	var close = function() {
		$html.removeClass( 'cookie-bar-active' );
	};

	$( document ).ready( _init );

	return {
		accept : accept,
		is_accepted : is_accepted,
		open : open,
		close : close
	};

} )( jQuery );

module.exports = cookie_notice;
},{}],2:[function(require,module,exports){
var fade_in = ( function( $ ) {

	var controller = null;

	var _init = function() {
		controller = new ScrollMagic.Controller();

		$( document ).on( 'pageloaded', _new_page );

		add_handlers( $( '.fade-in' ) );
	};

	var _new_page = function( e, page ) {
		add_handlers( page.find( '.fade-in' ) );
	};

	var add_handlers = function( $object ) {
		$object.each( function() {

			if ( $( this ).hasClass( 'fade-in' ) ) {
				var object = $( this ).get(0);

				new ScrollMagic.Scene( {
					triggerElement: object,
					reverse: false,
					triggerHook: 0.9
				} ).on('start', function () {
					_start_fade_in(object)
				} ).addTo(controller);
			}
		} );
	};

	var _start_fade_in = function( object ) {
		$( object ).addClass( 'done' );
	};

	$( document ).ready( _init );

	return {
		add_handlers: add_handlers
	};

} ) ( jQuery );

module.exports = fade_in;
},{}],3:[function(require,module,exports){
var utils = require( './utils.js' );

var footer = (function( $ ) {

	var _init = function() {
		$( '.menu-group .title' ).on( 'click', _toggle_expanded_item );
	};

	var _toggle_expanded_item = function() {
		var $group = $( this ).parent( '.menu-group' );
		console.log($group);
		var $open_groups = $( '.menu-group.expanded' ).not( $group );

		$open_groups.removeClass( 'expanded' );
		$open_groups.find( '.nav.footer-nav' ).slideUp();

		if ( $group.hasClass( 'expanded' ) ) {
			$group.removeClass( 'expanded' );
			$group.find( '.nav.footer-nav' ).slideUp();
		} else {
			$group.addClass( 'expanded' );
			$group.find( '.nav.footer-nav' ).slideDown	();
		}

		event.preventDefault();
	};

	if ( utils.viewport_size().width < 992 ) {
		$( document ).ready( _init );
	}

	return {};

})( jQuery );

module.exports = footer;
},{"./utils.js":15}],4:[function(require,module,exports){
var frontpage_engagements_slider = ( function ( $ ) {

	var $carousel = null;

	var _init = function () {
		$carousel = $( '.frontpage-recent-engagements' ).find( '.owl-carousel' );

		_setup_slider();
	};

	var _setup_slider = function () {
		$carousel.on( 'initialized.owl.carousel', _slider_initialised );

		$carousel.owlCarousel( {
			items: 1,
			loop: true,
			nav: false,
			dots: true
		} );
	};

	var _slider_initialised = function( event ) {
		$carousel.find( '.owl-item .item' ).show();
	};

	if ( $( '.frontpage-recent-engagements' ).length > 0 ) {
		_init();
	}

	return {};

})( jQuery );

module.exports = frontpage_engagements_slider;
},{}],5:[function(require,module,exports){
var frontpage_slider = (function ( $ ) {

	var $carousel = null;

	var _init = function () {
		$carousel = $( '#frontpage-slider' ).find( '.owl-carousel' );

		_setup_slider();
	};

	var _setup_slider = function () {
		$carousel.on( 'initialized.owl.carousel', _slider_initialised );

		$carousel.owlCarousel( {
			items: 1,
			loop: true,
			nav: false,
			dots: true,
			dotsContainer: $( '#frontpage-slider' ).find( '.owl-dots .container' ),
			autoplay: true,
			autoplayTimeout: 6000,
			animateOut: 'fadeOut'
		} );
	};

	var _slider_initialised = function( event ) {
		$carousel.find( '.owl-item .item' ).show();
	};

	if ( $( '#frontpage-slider' ).length > 0 ) {
		_init();
	}

	return {};

})( jQuery );

module.exports = frontpage_slider;
},{}],6:[function(require,module,exports){
var image_loading = ( function( $ ) {

	var _init = function() {
		$( '.image-wrapper.ajax-loader' ).find( 'img' ).each( setup_image );
		$( '.bg-image-wrapper.ajax-loader' ).find( '.bg-image' ).each( setup_bg_image );
	};

	var setup_image = function() {
		var src = $( this ).data( 'src' );

		$( this ).attr( 'src', src ).on( 'load', _image_loaded );
	};

	var _image_loaded = function( event ) {
		$( this ).closest( '.image-wrapper' ).addClass( 'loaded' );
	};

	var setup_bg_image = function() {
		var src = $( this ).data( 'src' );
		var $el = $( this );

		$( '<img />' ).attr( 'src', src ).on( 'load', function( event ) {
			$( this ).remove();
			$( $el ).removeAttr( 'style' ).css( 'background-image', "url('" + src + "')" );
			$el.closest( '.bg-image-wrapper' ).addClass( 'loaded' );
		} );
	};

	$( document ).ready( _init );

	return {
		'setup_image': setup_image,
		'setup_bg_image': setup_bg_image
	}

} )( jQuery );

module.exports = image_loading;
},{}],7:[function(require,module,exports){
(function( $ ) {

	$.fn.loading = function( loading_img ) {
		if ( typeof loading_img === 'undefined' && typeof ScriptData.ajax_loader_url !== 'undefined' ) {
			loading_img = ScriptData.ajax_loader_url;
		}

		this.fadeTo( '400', '0.5' ).block( {
			message: null, overlayCSS: {
				background: 'transparent url(' + loading_img + ') no-repeat center',
				backgroundSize: '16px 16px',
				opacity: 0.5
			}
		} );

		return this;
	};

	$.fn.loaded = function() {
		this.stop( true ).css( 'opacity', '1' ).unblock();

		return this;
	};

})( jQuery );
},{}],8:[function(require,module,exports){
var masonry_grid = ( function( $ ) {

	var $grid = null;

	var _init = function() {
		$grid = $( '.masonry-grid' );

		_setup_grid();
	};

	var _setup_grid = function() {
		$grid.imagesLoaded( function() {

			$grid.masonry( {
				itemSelector: '.grid-item',
				columnWidth: '.grid-item'
			} );

		} );
	};

	if ( $( '.masonry-grid' ).length > 0 ) {
		$( document ).ready( _init );
	}

	return {};

} )( jQuery );

module.exports = masonry_grid;
},{}],9:[function(require,module,exports){
var ocm_mobile_submenu = ( function( $ ) {

	var $ocm = null;

	var _init = function() {
		$ocm = $( '#off-canvas-menu-mobile' );

		$ocm.find( 'ul.nav li.menu-item-has-children' ).find( '>a' ).on( 'click', _toggle_submenu );
	};
	var _toggle_submenu = function( e ) {
		var $el = $( this ).closest( 'li' );

		if ( $el.hasClass( 'expanded' ) ) {
			close_submenu( $el );
		} else {
			open_submenu( $el );
		}

		e.preventDefault();
	};

	var open_submenu = function( $el ) {
		close_all_submenus();
		$el.addClass( 'expanded' );
		$el.find( 'ul.sub-menu' ).slideDown();
	};

	var close_submenu = function( $el ) {
		$el.removeClass( 'expanded' );
		$el.find( 'ul.sub-menu' ).slideUp();
	};

	var close_all_submenus = function() {
		$ocm.find( 'li.expanded ul.sub-menu' ).slideUp();
		$ocm.find( 'li.expanded' ).removeClass( 'expanded' );
	};

	$( document ).ready( _init );

	return {
		'open_submenu': open_submenu,
		'close_submenu': close_submenu,
		'close_all_submenus': close_all_submenus
	};

} )( jQuery );

module.exports = ocm_mobile_submenu;
},{}],10:[function(require,module,exports){
var ocm_submenu = ( function( $ ) {

	var $ocm = null;
	var $carousel = null;

	var _init = function() {
		$ocm = $( '#off-canvas-menu' );
		$carousel = $ocm.find( '.submenu-container .carousel' );
		_setup_slider();

		$ocm.find( 'ul.nav li' ).has( '.submenu-container' ).find( '>a' ).on( 'click', _toggle_submenu );
	};

	var _setup_slider = function() {
		$carousel.cycle( {
			fx: 'carousel',
			timeout: 0,
			next: '#submenu-next',
			prev: '#submenu-prev',
			slides: '> div',
			allowWrap: false
		} );
	};

	var _toggle_submenu = function( e ) {
		var $el = $( this ).closest( 'li' );

		if ( $el.hasClass( 'submenu-open' ) ) {
			close_submenu( $el );
		} else {
			open_submenu( $el );
		}

		e.preventDefault();
	};

	var open_submenu = function( $el ) {
		close_all_submenus();
		$ocm.addClass( 'submenu-open' );
		$el.addClass( 'submenu-open' );
	};

	var close_submenu = function( $el ) {
		$ocm.removeClass( 'submenu-open' );
		$el.removeClass( 'submenu-open' );
	};

	var close_all_submenus = function() {
		$ocm.removeClass( 'submenu-open' );
		$ocm.find( 'li.submenu-open' ).removeClass( 'submenu-open' );
	};

	$( document ).ready( _init );

	return {
		'open_submenu': open_submenu,
		'close_submenu': close_submenu,
		'close_all_submenus': close_all_submenus
	};

} )( jQuery );

module.exports = ocm_submenu;
},{}],11:[function(require,module,exports){
// require( '../bin/libs/owl/owl.carousel.js' );

var utils = require('./utils');
var ocm_submenu = require('./ocm-submenu');

var ocm = ( function( $ ) {

	var viewport = utils.viewport_size();
	var $document = $( document );
	var $html = $( 'html' );
	var $ocm = false;
	var $ocm_mobile = false;

	var transition_event = 'transition';

	var _init = function() {
		viewport = utils.viewport_size();

		transition_event = utils.which_transition_event();

		$ocm = $( '#off-canvas-menu' );
		$ocm_mobile = $( '#off-canvas-menu-mobile' );

		$( '.navbar-toggle' ).on( 'click', _ocm_toggle_click_event );
		$ocm.find( '.close' ).on( 'click', _ocm_close_click_event );
		$ocm_mobile.find( '.close' ).on( 'click', _ocm_close_click_event );

		$( window ).smartresize( _smart_resize_event );

		// $( window ).swipe( {
		// 	swipeLeft: _swipe_left_event,
		// 	swipeRight: _swipe_right_event,
		// 	threshold:0,
		// 	fingers:'all'
		// });
	};

	var _swipe_left_event = function( event ) {
		if ( $html.hasClass( 'ocm-right' ) ) {
			open_ocm();
		} else {
			close_ocm();
		}
	};

	var _swipe_right_event = function( event ) {
		if ( $html.hasClass( 'ocm-right' ) ) {
			close_ocm();
		} else {
			open_ocm();
		}
	};

	var _smart_resize_event = function( event ) {
		viewport = utils.viewport_size();

		if ( viewport.width <= 992 ) {
			var timeout = 0;

			if ( $ocm.hasClass( 'submenu-open' ) ) {
				ocm_submenu.close_all_submenus();
				timeout += 1000;
			}

			setTimeout( _close_desktop_ocm, timeout );
		} else {
			$html.removeClass( 'ocm-mobile-open' );
		}
	};

	var _close_desktop_ocm = function() {
		$html.removeClass( 'ocm-open' );
	};

	var _ocm_close_click_event = function( event ) {
		close_ocm();

		return false;
	};

	var _ocm_toggle_click_event = function( event ) {
		if ( $html.hasClass( 'ocm-open' ) || $html.hasClass( 'ocm-mobile-open' ) ) {
			close_ocm();
		} else {
			open_ocm();
		}

		return false;
	};

	var open_ocm = function() {
		setTimeout( _start_open_ocm, 25 );
	};

	var _start_open_ocm = function() {
		if ( viewport.width <= 992 ) {
			$html.addClass( 'ocm-mobile-open' );
		} else {
			$html.addClass( 'ocm-open' );
		}
		$document.on( 'click', _body_click_event );
	};

	var close_ocm = function() {
		var timeout = 25;

		if ( $ocm.hasClass( 'submenu-open' ) ) {
			ocm_submenu.close_all_submenus();
			timeout += 1000;
		}

		setTimeout( _start_close_ocm, timeout );
	};

	var _start_close_ocm = function() {
		$document.off( 'click', _body_click_event );

		$ocm.on( transition_event , _ocm_closed_event );

		if ( viewport.width <= 992 ) {
			$html.removeClass( 'ocm-mobile-open' );
		} else {
			$html.addClass( 'ocm-closing' );
			$html.removeClass( 'ocm-open' );
		}
	};

	var _ocm_closed_event = function( event ) {
		$html.removeClass( 'ocm-closing' );

		$( this ).off( event );
	};

	var _body_click_event = function( event ) {
		if ( $( event.target ).closest( '#off-canvas-menu' ).length == 0 && $( event.target ).closest( '#off-canvas-menu-mobile' ).length == 0 ) {
			close_ocm();
		}
	};

	var _hide_yt_watermark = function() {

	};

	$( document ).ready( _init );

} )( jQuery );

module.exports = ocm;
},{"./ocm-submenu":10,"./utils":15}],12:[function(require,module,exports){
var frontpage_slider = (function ( $ ) {

	var $carousel = null;

	var _init = function () {
		$carousel = $( '#recent-engagements-carousel' ).find( '.owl-carousel' );

		_setup_slider();
	};

	var _setup_slider = function () {
		$carousel.on( 'initialized.owl.carousel', _slider_initialised );

		var icons_dir = ScriptData.theme_uri + '/assets/icons';

		$carousel.owlCarousel( {
			items: 1,
			loop: true,
			nav: true,
			navText: [
				'<img class="prev" src="' + icons_dir + '/arrow-left-white.svg" />',
				'<img class="next" src="' + icons_dir + '/arrow-right-white.svg" />'
			],
			dots: false,
			animateOut: 'fadeOut',
			autoHeight: true
		} );
	};

	var _slider_initialised = function( event ) {
		$carousel.find( '.owl-item .item' ).show();
	};

	if ( $( '#recent-engagements-carousel' ).length > 0 ) {
		_init();
	}

	return {};

})( jQuery );

module.exports = frontpage_slider;
},{}],13:[function(require,module,exports){
image_loading = require('./image-loading');

var scroll_load = ( function ( $ ) {

	// Pages to load in advance, before the user scrolls to them
	const PAGES_AHEAD = 2;
	// Number of pages that have already been loaded by the initial request
	const PAGES_PRE_LOADED = 1;
	// Container of pages
	const PAGES_CONTAINER = '.infinite-grid';

	var pages_loaded = PAGES_PRE_LOADED;
	var pages_loading = false;
	var enabled = true;
	var $pages_container = null;
	var scroll_points = [];

	var _add_to_queue = function( value ) {
		scroll_points.push( value );
	};

	var _pop_queue = function() {
		scroll_points.shift();
	};

	var _process_new_page = function( $page ) {
		_insert_page( $page );
		pages_loaded++;
		pages_loading = false;

		if ( scroll_points.length > PAGES_AHEAD ) {
			_pop_queue();
		}

		_add_to_queue( $pages_container.height() );
	};

	var _init = function() {
		$pages_container = $( PAGES_CONTAINER );
		_add_to_queue( $pages_container.height() );
		_check_next_page();
	};

	var _get_next_page = function() {

		var data = {
			action: 'get_posts',
			scroll_load_nonce: ScriptData.scroll_load_nonce,
			query_vars: ScriptData.query_vars,
			page: pages_loaded + 1
		};

		$.post( ScriptData.ajaxurl, data, _received_page );
//		$pages_container.loading();
		pages_loading = true;
	};

	var _received_page = function( response ) {
		if ( response.html ) {
			var $page = $( $.parseHTML( response.html ) );
			_process_new_page( $page );

			$( document ).trigger( 'pageloaded', [$page] );
			_check_next_page();
		} else {
			enabled = false;
		}
	};

	var _insert_page = function( html ) {
		$( html ).find( '.image-wrapper.ajax-loader' ).find( 'img' ).each( image_loading.setup_image );
		$( html ).find( '.bg-image-wrapper.ajax-loader' ).find( '.bg-image' ).each( image_loading.setup_bg_image );
		$pages_container.append( html );
//		$pages_container.loaded();
	};

	var _check_next_page = function() {
		if ( enabled && ! pages_loading ) {
			var get_next_page = false;

			var distance_from_bottom = scroll_points[0] - window.scrollY + $pages_container.offset().top - $( window ).height();
			if ( distance_from_bottom < 0 ) {
				get_next_page = true;
			}

			if ( scroll_points.length <= PAGES_AHEAD ) {
				get_next_page = true;
			}

			if ( get_next_page ) {
				_get_next_page();
			}
		}
	};

	if ( $( '.infinite-grid' ).length > 0 ) {
		$( document ).on( 'ready', _init );
		$( document ).scroll( _check_next_page );
	}

	return {};

} ) ( jQuery );

module.exports = scroll_load;


},{"./image-loading":6}],14:[function(require,module,exports){
var service_archive_intro = ( function( $ ) {

	var $intro;

	var _init = function() {
		$intro = $( '#service-intro' );
		
		if ( $intro.find( 'a.toggle-panel-link' ).length > 0 ) {
			$intro.find( 'a.toggle-panel-link' ).on( 'click', _toggle_panel );
		}
	};

	var _toggle_panel = function( e ) {
		e.preventDefault();
		$( this ).closest( '.panel-container' ).toggleClass( 'open' );
		$intro.find( '.toggle-panel' ).slideToggle();
	};

	if ( $( '#service-intro' ).length > 0 ) {
		$( document ).ready( _init );
	}

} ) ( jQuery );

module.exports = service_archive_intro;
},{}],15:[function(require,module,exports){
var utils = (function( $ ) {

	/*
	 * Returns the viewport size, including scrollbars - which matches media queries
	 *
	 * http://andylangton.co.uk/blog/development/get-viewport-size-width-and-height-javascript
	 */
	var viewport_size = function() {
		var e = window, a = 'inner';
		if ( !( 'innerWidth' in window ) ) {
			a = 'client';
			e = document.documentElement || document.body;
		}
		return { width: e[a + 'Width'], height: e[a + 'Height'] };
	};

	// Function from David Walsh: http://davidwalsh.name/css-animation-callback
	var which_transition_event = function() {
		var t, el = document.createElement( "fakeelement" );

		var transitions = {
			"transition": "transitionend",
			"OTransition": "oTransitionEnd",
			"MozTransition": "transitionend",
			"WebkitTransition": "webkitTransitionEnd"
		};

		for ( t in transitions ) {
			if ( el.style[t] !== undefined ) {
				return transitions[t];
			}
		}
	};

	return {
		viewport_size: viewport_size,
		which_transition_event: which_transition_event
	};

})( jQuery );

module.exports = utils;
},{}],16:[function(require,module,exports){
require('./js/cookie-notice.js');require('./js/fade-in.js');require('./js/footer.js');require('./js/frontpage-engagements-slider.js');require('./js/frontpage-slider.js');require('./js/image-loading.js');require('./js/loading.js');require('./js/masonry-grid.js');require('./js/ocm-mobile-submenu.js');require('./js/ocm-submenu.js');require('./js/ocm.js');require('./js/recent-engagements-carousel.js');require('./js/scroll_load.js');require('./js/service-archive-intro.js');require('./js/utils.js');
},{"./js/cookie-notice.js":1,"./js/fade-in.js":2,"./js/footer.js":3,"./js/frontpage-engagements-slider.js":4,"./js/frontpage-slider.js":5,"./js/image-loading.js":6,"./js/loading.js":7,"./js/masonry-grid.js":8,"./js/ocm-mobile-submenu.js":9,"./js/ocm-submenu.js":10,"./js/ocm.js":11,"./js/recent-engagements-carousel.js":12,"./js/scroll_load.js":13,"./js/service-archive-intro.js":14,"./js/utils.js":15}]},{},[16]);
